import { useEffect, useState } from "react";
import AppShell from "@/components/layout/AppShell";
import api, { fmtError } from "@/lib/api";
import { DataTable, Modal, Btn, Field, TextInput, Icons } from "@/components/ui-lite";
import { toast } from "sonner";

const empty = { code: "", name: "", symbol: "", enabled: true };

export default function AdminCurrenciesPage() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/currencies").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/currencies/${editing.id}`, form);
      else await api.post("/currencies", form);
      toast.success("Saved"); setOpen(false); setEditing(null); setForm(empty); load();
    } catch (e) { toast.error(fmtError(e)); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete currency?")) return;
    try { await api.delete(`/currencies/${id}`); load(); }
    catch (e) { toast.error(fmtError(e)); }
  };

  return (
    <AppShell
      title="Currencies"
      subtitle="Manage the currency catalogue used across Brands, FX rates and Invoices"
      actions={<Btn data-testid="cur-add" onClick={() => { setEditing(null); setForm(empty); setOpen(true); }}><Icons.Plus size={16} className="inline mr-1"/> New currency</Btn>}
    >
      <DataTable
        testid="currencies-table"
        columns={[
          { key: "code", label: "Code", mono: true },
          { key: "name", label: "Name" },
          { key: "symbol", label: "Symbol", mono: true },
          { key: "enabled", label: "Enabled", render: (r) => r.enabled ? "yes" : "no" },
        ]}
        rows={rows}
        actions={(r) => (
          <div className="flex gap-2">
            <button data-testid={`cur-edit-${r.code}`} onClick={() => { setEditing(r); setForm({ code: r.code, name: r.name, symbol: r.symbol || "", enabled: r.enabled !== false }); setOpen(true); }} className="text-[var(--wv-text-2)] hover:text-[var(--wv-primary)]"><Icons.Pencil size={16}/></button>
            <button data-testid={`cur-del-${r.code}`} onClick={() => del(r.id)} className="text-[var(--wv-text-2)] hover:text-[var(--wv-error)]"><Icons.Trash2 size={16}/></button>
          </div>
        )}
      />

      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit currency" : "New currency"}
        footer={<>
          <Btn variant="secondary" onClick={() => setOpen(false)}>Cancel</Btn>
          <Btn data-testid="cur-save" onClick={save}>Save</Btn>
        </>}>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Code"><TextInput data-testid="cur-code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} placeholder="EUR" className="font-mono"/></Field>
          <Field label="Symbol"><TextInput data-testid="cur-symbol" value={form.symbol} onChange={(e) => setForm({ ...form, symbol: e.target.value })} placeholder="€" className="font-mono"/></Field>
          <div className="col-span-2"><Field label="Name"><TextInput data-testid="cur-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Euro"/></Field></div>
          <div className="col-span-2 flex items-center gap-2">
            <input id="enabled" type="checkbox" checked={form.enabled} onChange={(e) => setForm({ ...form, enabled: e.target.checked })}/>
            <label htmlFor="enabled" className="text-sm text-[var(--wv-text-2)]">Enabled (visible in brand & invoice pickers)</label>
          </div>
        </div>
      </Modal>
    </AppShell>
  );
}
